module.exports = __webpack_public_path__ + "static/img-macbook-28f50e8dc62e69f62443c9bd25cc6635.png";